// Sizes such as "1920×150" inside Arabic text are shown reversed ("150×1920") by the browser's
// right-to-left layout: the "×" between two numbers takes the paragraph's direction. On Arabic pages
// this wraps each size in <bdi dir="ltr">, so it always reads width × height, as written. Nothing else
// in the text changes, and the stored text stays exactly as it is (search engines read it unchanged).
//
// Loaded on Arabic pages only (layout/theme.liquid). Runs once when the page is ready, again when the
// theme editor reloads a section, and on content the page adds later (a drawer, a quick view).
(function () {
  "use strict";
  if ((document.documentElement.getAttribute("dir") || "").toLowerCase() !== "rtl") return;

  // Two numbers of two to five digits around × or x: 1920×150, 1080x1920, 96 × 96.
  var SIZE = /\d{2,5}\s?[×xX]\s?\d{2,5}/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, CODE: 1, PRE: 1, BDI: 1, SVG: 1, TEMPLATE: 1 };

  function skipped(el) {
    for (var e = el; e && e !== document.body; e = e.parentElement) {
      if (SKIP[e.nodeName.toUpperCase()] || e.isContentEditable) return true;
      // Already left-to-right: a size there reads correctly.
      if ((e.getAttribute("dir") || "").toLowerCase() === "ltr") return true;
    }
    return false;
  }

  function isolate(root) {
    if (!root || !root.ownerDocument) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        SIZE.lastIndex = 0;
        return SIZE.test(n.nodeValue) && !skipped(n.parentElement) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });
    var nodes = [];
    for (var n = walker.nextNode(); n; n = walker.nextNode()) nodes.push(n);
    nodes.forEach(function (node) {
      var text = node.nodeValue, frag = document.createDocumentFragment(), last = 0, m;
      SIZE.lastIndex = 0;
      while ((m = SIZE.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var bdi = document.createElement("bdi");
        bdi.setAttribute("dir", "ltr");
        bdi.textContent = m[0];
        frag.appendChild(bdi);
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function run() { isolate(document.body); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run, { once: true });
  else run();
  document.addEventListener("shopify:section:load", function (e) { isolate(e.target); });

  // Content added later: looked at in one batch per frame, so a busy page is not slowed down.
  if (window.MutationObserver) {
    var pending = [], queued = false;
    new MutationObserver(function (records) {
      records.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1 && n.nodeName !== "BDI") pending.push(n); }); });
      if (pending.length && !queued) {
        queued = true;
        requestAnimationFrame(function () { var list = pending; pending = []; queued = false; list.forEach(function (el) { if (el.isConnected) isolate(el); }); });
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
